module.exports = __webpack_public_path__ + "img/btn_go1.1a80acad.png";